import * as React from 'react';
import { useGenerateTokenMutation } from '../../../generated/auth/graphql-react-query';
import isCancelledRequestError from '../../../utils/isCancelledRequestError';
import { useCookieContext } from '../../Hooks/useUserInfo';
import { AmplifyTokens } from './useAmplifyTokenRefresh';

export default function useGeneratedLiveToken(amplifyTokens: AmplifyTokens | null) {
  const { token, setToken } = useCookieContext();

  const {
    error: generateError,
    isError,
    isLoading,
    mutate: generate,
    reset,
  } = useGenerateTokenMutation({
    retry(failureCount, error) {
      return isCancelledRequestError(error) && failureCount < 3;
    },
    onSuccess(data) {
      setToken(data.generateToken);
    },
    onError(nextError) {
      console.error('Error generating token', nextError);
    },
  });

  const generateRef = React.useRef(generate);
  React.useEffect(() => {
    generateRef.current = generate;
  }, [generate]);

  React.useEffect(() => {
    if (amplifyTokens) {
      generateRef.current({});
    }
  }, [amplifyTokens]);

  return {
    token,
    isReady: !!token,
    error: generateError,
    isError,
    isLoading,
    generate,
    reset,
  };
}
